import { useContext, useEffect, useState } from 'react'
import { enqueueSnackbar } from 'notistack'
import moment from 'moment-timezone'

import { Dialog, DialogActions, DialogContent, DialogTitle, Button, TextField } from '@mui/material'
import SyncOutlinedIcon from '@mui/icons-material/SyncOutlined'

import { AppContext } from '/providers/app-context'
import { notifyPasses, notifyPass } from '/providers/passes-api'

const NodifySelectedDialog = ({ open, setOpen, template, passes, refresh }) => {

  const { client, apiSource, apiKey, processing, setProcessing } = useContext(AppContext)
  const [notification, setNotification] = useState("")
  const [limitedUpdates, setLimitedUpdates] = useState(false)

  useEffect(() => {
    if (client.limitUpdates) { // Client is only permitted  a limite dnumnber of updates per 24 hours

      passes.map(pass => {
        if (pass.update_counter >= client.updates_per_day) {
          setLimitedUpdates(true)
        }
      })
    }
  }, [client, passes])


  if (!template) return null

  const doSyncPasses = async () => {
    close()
    setProcessing(true)
    enqueueSnackbar({ message: 'Notifying passes', variant: 'light' })

    if (passes.length > 1) {
      const result = await notifyPasses({ apiSource, apiKey, templateId: template.id, passes, notification })

      if (result.ok) {
        enqueueSnackbar({ message: 'Notifications queued', variant: 'success' })
      } else {
        enqueueSnackbar({ message: 'Notification failed', variant: 'error' })
      }
    } else {
      const result = await notifyPass({ apiSource, apiKey, templateId: template.id, passId: passes[0], notification })

      if (result.ok) {
        enqueueSnackbar({ message: 'Notification sent', variant: 'success' })
      } else {
        enqueueSnackbar({ message: 'Notification failed', variant: 'error' })
      }
    }

    if (refresh) refresh()
    setProcessing(false)
    setNotification("")
  }

  const close = () => setOpen(false)

  return (
    <Dialog
      open={open}
      onClose={close}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">
        Notify Selected Passes : {template.name} [{limitedUpdates ? "Y" : "N"}]
      </DialogTitle>

      {limitedUpdates &&
        <DialogContent>
          <div style={{ width: 600 }} className='flex flex-col gap-5'>
            <div>One or more passes has been updated or notified recently.</div>

            <div>
              Since you are using Smartix signing certifiates, you are limited to one pass update per 24 hours.
            </div>

            <div>
              If you require more frequent pass updates / notifications then please register your own Apple and Google developer accounts
              and provide us with your own signing certificates.
            </div>
          </div>
        </DialogContent>
      }
      {!limitedUpdates &&
        <DialogContent>
          <div style={{ width: 600 }} className='flex flex-col gap-5'>
            <p>This will send a notification to the selected [{passes.length}] passes.</p>

            <TextField value={notification} label="Notification text" sx={{ width: 550 }}
              onChange={e => setNotification(e.target.value.substring(0, 255))}
              slotProps={{ inputLabel: { shrink: true } }}
              autoFocus
              type="search" />
          </div>
        </DialogContent>
      }

      <DialogActions>
        <div className="flex flex-row justify-between w-full p-5">
          <Button variant="outlined" onClick={close} disabled={processing}>Cancel</Button>
          <Button variant="contained" onClick={doSyncPasses} autoFocus disabled={processing || notification.length < 5 || limitedUpdates}><SyncOutlinedIcon className="mr-5" />Notify Selected Passes</Button>
        </div>
      </DialogActions>
    </Dialog>
  )
}

export default NodifySelectedDialog